import React from 'react'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../../styledComponents/Constants'

export interface InputError {
    commentId?: number
    title: string,
    messages: string[],
    fileNameList?: string[]
}

interface Props {
    inputError: InputError
}

const NatDisasterCommentError: React.FC<Props> = props => {
    const {title, messages, fileNameList} = props.inputError
    return (
        <ErrorMessageArea>
            <ErrorMessageTitle>
                {title}
            </ErrorMessageTitle>
            <Box height={'5px'}/>
            {messages.map((message, index) =>
                <ErrorMessage key={'errorMessage-' + index}>
                    {message}
                </ErrorMessage>)}
            {
                fileNameList &&
                fileNameList.length > 0 && <>
                    <Box height={'5px'}/>
                    {
                        fileNameList.map((fileName, index) =>
                            <ErrorMessage key={'errorFile-' + index}>
                                {fileName}
                            </ErrorMessage>)
                    }
                </>
            }
        </ErrorMessageArea>
    )
}

export default NatDisasterCommentError

const ErrorMessageArea = styled.div`
    width: 100%;
    box-sizing: border-box;
    background: #fbebec;
    padding: 10px;
`

const ErrorMessageTitle = styled.div`
    color: ${Colors.Alert};
    font-size: ${FontSize.Body};
    font-weight: ${FontWeights.Bold};
    line-height: 24px;
`

const ErrorMessage = styled.div`
    color: ${Colors.Body};
    font-size: ${FontSize.Middle};
    line-height: 21px;
    white-space: pre-wrap;
`
